module.exports = __webpack_public_path__ + "img/PBSDLogo.b764fd7a.png";